import { ROUTES } from "../../routes.js";
import { SparkOverviewWithData } from "../workshops/spark-overview/SparkOverviewWithData.jsx";
import { useSparkContext } from "../workshops/context/SparkContext.jsx";

/**
 * Represents a component that displays an overview of a Spark within a workshop.
 * This component mainly takes care of gathering the data, which it then fills into
 * another component to display.
 *
 * Similar to /workshops/spark-overview/SparkOverview.jsx, but sets a flag to disable some steps.
 *
 * @returns The rendered SparkOverview component.
 */
const SparkOverview = () => {
  const { spark, structure } = useSparkContext();

  if (structure?.length === 0) {
    return <p>Lernreise hat noch keine Inhalte.</p>;
  }

  return (
    <SparkOverviewWithData
      baseUrl={ROUTES.demoLernreise.getUrl({ sparkSlug: spark.slug })}
      sparkSlug={spark.slug}
      phases={structure}
      templateTitle={spark.inAppTitle}
      disableSome={true}
    />
  );
};

export default SparkOverview;
